module.exports = __webpack_public_path__ + "img/78.6f53edf5.jpg";